
import { isFunction } from 'lodash';
import { postPartnerBalanceCorrection } from '../api/postPartnerBalanceCorrection';

export const setPostPartnerBalanceCorrection = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postPartnerBalanceCorrection(params);
            if (isFunction(callback)) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}